<template>
  <div class="login">
    <div class="card">
      <div class="title">宇航物流管理平台</div>
      <el-form :model="form" @submit.native.prevent @keyup.enter.native="onLogin">
        <el-form-item>
          <el-input v-model="form.username" placeholder="用户名" autocomplete="off" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.password" type="password" placeholder="密码" autocomplete="off" />
        </el-form-item>
        <el-form-item>
          <div class="captcha-row">
            <el-input
              v-model="form.captchaCode"
              maxlength="4"
              placeholder="请输入4位数字验证码"
              autocomplete="off"
            />
            <img
              v-if="captchaImageBase64"
              class="captcha-image"
              :src="captchaImageBase64"
              alt="验证码"
              @click="fetchCaptcha"
            />
          </div>
        </el-form-item>
        <el-button type="primary" style="width:100%" :loading="loading" @click="onLogin">登录</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'
import { setToken, setUser, setMenus } from '../utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      captchaImageBase64: '',
      form: {
        username: '',
        password: '',
        captchaKey: '',
        captchaCode: ''
      }
    }
  },
  created() {
    this.fetchCaptcha()
  },
  methods: {
    async fetchCaptcha() {
      const data = await request.get('/admin/api/auth/captcha')
      this.form.captchaKey = data.captchaKey || ''
      this.form.captchaCode = ''
      this.captchaImageBase64 = data.captchaImageBase64 || ''
    },
    async onLogin() {
      if (this.loading) return
      if (!/^\d{4}$/.test(this.form.captchaCode || '')) {
        this.$message.warning('请输入4位数字验证码')
        return
      }

      this.loading = true
      try {
        const payload = {
          username: this.form.username,
          password: this.form.password,
          captchaKey: this.form.captchaKey,
          captchaCode: this.form.captchaCode
        }
        const res = await request.post('/admin/api/auth/login', payload)
        setToken(res.token)
        setUser(res.user)
        const menus = await request.get('/admin/api/auth/menus')
        setMenus(menus)
        this.$router.replace('/')
      } catch (e) {
        this.$message.error(e.message || '登录失败')
        await this.fetchCaptcha()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.login {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0ea5e9, #6366f1);
}
.card {
  width: 360px;
  background: #fff;
  border-radius: 14px;
  padding: 22px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, .25);
}
.title {
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 12px;
  color: #0f172a;
}
.captcha-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.captcha-row .el-input {
  flex: 1;
}
.captcha-image {
  width: 120px;
  height: 40px;
  display: block;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  user-select: none;
  object-fit: contain;
  background: #fff;
  flex-shrink: 0;
}
.hint {
  margin-top: 10px;
  font-size: 12px;
  color: #64748b;
}
</style>
